var _desc, _defs, _path, _path2, _line, _path3, _path4, _path5, _g, _g2, _g3, _g4, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 700",
    width: 1200,
    height: 700,
    role: "img",
    "aria-labelledby": titleId,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Backend Engineer Illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Backend engineer illustration with servers, terminal, database, cloud, gears, and deployment status.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgBlob",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "purpleGlow",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#55198b",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55198b",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "panelGrad",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("filter", {
    id: "softShadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 12,
    floodColor: "#000",
    floodOpacity: 0.18
  })), /*#__PURE__*/React.createElement("filter", {
    id: "tinyShadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 4,
    floodColor: "#000",
    floodOpacity: 0.14
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cardClip"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 150,
    width: 760,
    height: 410,
    rx: 28
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190 150c120-120 330-140 480-50 90 55 165 150 270 160 115 12 205-105 320-100 105 5 185 105 200 210 15 112-40 230-120 305-105 98-240 138-375 134-135-4-246-55-345-135-96-78-188-165-235-279-48-117-10-246 105-345z",
    fill: "url(#bgBlob)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M980 70c75 35 105 125 72 196-36 76-129 116-210 88-73-26-108-116-78-191 32-77 136-130 216-93z",
    fill: "#f2f2f2",
    opacity: 0.7
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 90,
    y1: 640,
    x2: 1110,
    y2: 640,
    stroke: "#3f3d56",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130 640c0-62 43-112 98-112",
    fill: "none",
    stroke: "#55198b",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130 640c0-96 67-174 152-174",
    fill: "none",
    stroke: "#46455b",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M130 640c0-46 20-84 45-84",
    fill: "none",
    stroke: "#55198b",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#softShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 150,
    width: 760,
    height: 410,
    rx: 28,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 170,
    width: 720,
    height: 370,
    rx: 22,
    fill: "url(#panelGrad)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M520 132c10-38 44-64 85-64 36 0 66 20 78 52 26-4 51 10 63 34 16 34-2 74-38 86H544c-35 0-63-28-63-63 0-29 20-53 49-61z",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520 132c10-38 44-64 85-64 36 0 66 20 78 52 26-4 51 10 63 34 16 34-2 74-38 86H544c-35 0-63-28-63-63 0-29 20-53 49-61z",
    fill: "url(#purpleGlow)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(930 210)",
    filter: "url(#tinyShadow)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-40 -30)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 44,
    fill: "#fff",
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    r: 18,
    fill: "#3f3d56",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#55198b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: -70,
    width: 10,
    height: 18,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: 52,
    width: 10,
    height: 18,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -70,
    y: -5,
    width: 18,
    height: 10,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: -5,
    width: 18,
    height: 10,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -52,
    y: -52,
    width: 16,
    height: 10,
    rx: 4,
    transform: "rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -52,
    y: 42,
    width: 16,
    height: 10,
    rx: 4,
    transform: "rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: -52,
    width: 16,
    height: 10,
    rx: 4,
    transform: "rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 42,
    width: 16,
    height: 10,
    rx: 4,
    transform: "rotate(-45)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55 45)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 34,
    fill: "#fff",
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    r: 13,
    fill: "#3f3d56",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#46455b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4,
    y: -54,
    width: 8,
    height: 16,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4,
    y: 38,
    width: 8,
    height: 16,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -54,
    y: -4,
    width: 16,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: -4,
    width: 16,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40,
    y: -40,
    width: 14,
    height: 8,
    rx: 4,
    transform: "rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40,
    y: 32,
    width: 14,
    height: 8,
    rx: 4,
    transform: "rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: -40,
    width: 14,
    height: 8,
    rx: 4,
    transform: "rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 32,
    width: 14,
    height: 8,
    rx: 4,
    transform: "rotate(-45)"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cardClip)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(270 210)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 230,
    height: 320,
    rx: 22,
    fill: "#55198b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 18,
    width: 198,
    height: 86,
    rx: 16,
    fill: "#3f3d56",
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 118,
    width: 198,
    height: 86,
    rx: 16,
    fill: "#3f3d56",
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 218,
    width: 198,
    height: 86,
    rx: 16,
    fill: "#3f3d56",
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 30,
    width: 92,
    height: 10,
    rx: 5,
    fill: "#f2f2f2",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 48,
    width: 132,
    height: 10,
    rx: 5,
    fill: "#f2f2f2",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 148,
    width: 120,
    height: 10,
    rx: 5,
    fill: "#f2f2f2",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 248,
    width: 108,
    height: 10,
    rx: 5,
    fill: "#f2f2f2",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160 46)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 7,
    fill: "#57b894"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 0,
    r: 7,
    fill: "#f2f2f2",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 0,
    r: 7,
    fill: "#f2f2f2",
    opacity: 0.65
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160 146)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 7,
    fill: "#57b894"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 0,
    r: 7,
    fill: "#f2f2f2",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 0,
    r: 7,
    fill: "#f2f2f2",
    opacity: 0.65
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160 246)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 7,
    fill: "#57b894"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 0,
    r: 7,
    fill: "#f2f2f2",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 0,
    r: 7,
    fill: "#f2f2f2",
    opacity: 0.65
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 26,
    width: 6,
    height: 278,
    rx: 3,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 26,
    width: 6,
    height: 278,
    rx: 3,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "#f2f2f2",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M520 320h55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 300l25 20-25 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575 382H520",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540 362l-25 20 25 20",
    opacity: 0.75
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(610 220)",
    filter: "url(#tinyShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 320,
    height: 260,
    rx: 18,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 320,
    height: 40,
    rx: 18,
    fill: "#55198b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 20,
    r: 7,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 20,
    r: 7,
    fill: "#f2f2f2",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 20,
    r: 7,
    fill: "#f2f2f2",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22 66)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 240,
    height: 12,
    rx: 6,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 22,
    width: 210,
    height: 12,
    rx: 6,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 44,
    width: 255,
    height: 12,
    rx: 6,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 66,
    width: 180,
    height: 12,
    rx: 6,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 88,
    width: 230,
    height: 12,
    rx: 6,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 110,
    width: 130,
    height: 12,
    rx: 6,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 146,
    width: 270,
    height: 12,
    rx: 6,
    fill: "#55198b",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 168,
    width: 220,
    height: 12,
    rx: 6,
    fill: "#55198b",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 204,
    width: 200,
    height: 12,
    rx: 6,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 204,
    width: 12,
    height: 12,
    rx: 3,
    fill: "#55198b"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520 470)",
    filter: "url(#tinyShadow)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 90,
    ry: 22,
    fill: "#ffffff",
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-90 0v78c0 12 40 22 90 22s90-10 90-22V0",
    fill: "#ffffff",
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 78,
    rx: 90,
    ry: 22,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 90,
    ry: 22,
    fill: "#55198b",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-90 26c0 12 40 22 90 22s90-10 90-22",
    fill: "none",
    stroke: "#e6e6e6",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-90 52c0 12 40 22 90 22s90-10 90-22",
    fill: "none",
    stroke: "#e6e6e6",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -54,
    y: 22,
    width: 108,
    height: 30,
    rx: 10,
    fill: "#3f3d56",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40,
    y: 34,
    width: 80,
    height: 6,
    rx: 3,
    fill: "#f2f2f2",
    opacity: 0.85
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(900 520)",
    filter: "url(#tinyShadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 42,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 32,
    fill: "#57b894",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-18 2l11 11 25-28",
    fill: "none",
    stroke: "#57b894",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 600,
    cy: 622,
    rx: 280,
    ry: 18,
    fill: "#000",
    opacity: 0.08
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackend);
export default __webpack_public_path__ + "static/media/backend.70023da20c8b95da03bb146e9f5a59c9.svg";
export { ForwardRef as ReactComponent };